import { gql } from '__generated__';

export default gql(`
  query GetTeam($team_id: ID!) {
    team(id: $team_id) {
      ...TeamFieldsFragment
    }
  }
`);
